import { GetPrimeTradeDetailsData } from "@services/models/Prime/GetPrimeTradeDetailsModel";

const COMPLETED_EVENT_IDS = new Set(["4", "6"]);

export const isPrimeTradeCompleted = (
  data?: Pick<GetPrimeTradeDetailsData, "eventId" | "eventDetails"> | null,
): boolean => {
  if (!data) return false;

  if (COMPLETED_EVENT_IDS.has(String(data.eventId))) {
    return true;
  }

  return (
    data.eventDetails?.some((event) =>
      COMPLETED_EVENT_IDS.has(String(event.eventId)),
    ) ?? false
  );
};
